export const reportDWHBuilder = (mode, params, props) => {
  const customerNumber = props.portalState.customerNumber;
  const formType = props.portalState.formType;
  const selectedHetPay = props.portalState.selectedHetPay;

  let report;
  switch (mode) {
    case 'SHOWPAGE':
      report = {
        subArea: 'SubsciberNameUpdate',
        actionType: 'Subscriber Search Page',
        status: 'Ongoing',
        messageText: 'Subscriber Search Page Displayed',
        param1: params?.param1 ?? '',
      };
      break;
    case 'BUTTON_CLICK':
      report = {
        subArea: 'SubsciberNameUpdate',
        actionType: 'Subscriber Search Page',
        messageText: 'Subscriber Search Page Button Clicked',
        status: 'Ongoing',
        param1: params?.param1 ?? '',
        param2: params?.param2 ?? '',
        param10: params?.param10 ?? '',
      };
      break;
    case 'SUB_NOT_FOUND':
      report = {
        subArea: 'SubsciberNameUpdate',
        actionType: 'Subscriber Search Page',
        messageText: 'Subscriber Not Found',
        status: 'Ongoing',
        param1: params?.param1 ?? '',
        param2: params?.param2 ?? '',
        param10: params?.param10 ?? '',
      };
      break;
    case 'SUB_DIFF_ORG':
      report = {
        subArea: 'SubsciberNameUpdate',
        actionType: 'Subscriber Search Page',
        messageText: 'Subscriber associated with another business account',
        status: 'Ongoing',
        param1: params?.param1 ?? '',
        param2: params?.param2 ?? '',
        param10: params?.param10 ?? '',
      };
      break;
    case 'GEN_ERR':
      report = {
        subArea: 'SubsciberNameUpdate',
        actionType: 'Subscriber Search Page',
        messageText: 'General Error',
        status: 'Error',
        param1: params?.param1 ?? '',
        param2: params?.param2 ?? '',
        param10: params?.param10 ?? '',
      };
      break;
    case 'SUCCESS_PAGE':
      report = {
        subArea: 'SubsciberNameUpdate',
        actionType: 'Subscriber Details Page',
        messageText: 'Subscriber Details Page Displayed',
        status: 'Ongoing',
        param1: params?.param1 ?? '',
        param2: params?.param2 ?? '',
        param10: params?.param10 ?? '',
      };
      break;
    case 'UPDATE_CLICKED':
      report = {
        subArea: 'SubsciberNameUpdate',
        actionType: 'Subscriber Details Page',
        messageText: 'Subscriber Name Update Clicked',
        status: 'Ongoing',
        param1: params?.param1 ?? '',
        param2: params?.param2 ?? '',
        param10: params?.param10 ?? '',
      };
      break;
    case 'UPDATE_DISPLAYED':
      report = {
        subArea: 'SubsciberNameUpdate',
        actionType: 'Subscriber Name Update State',
        messageText: 'Subscriber Name Update State Displayed',
        status: 'Ongoing',
        param1: params?.param1 ?? '',
        param2: params?.param2 ?? '',
        param10: params?.param10 ?? '',
      };
      break;
    case 'UPDATE_BTN_CLICKED':
      report = {
        subArea: 'SubsciberNameUpdate',
        actionType: 'Subscriber Name Update State',
        messageText: 'Subscriber Name Update Button Clicked',
        status: 'Ongoing',
        param1: params?.param1 ?? '',
        param2: params?.param2 ?? '',
        param10: params?.param10 ?? '',
      };
      break;
    case 'UPDATE_SUCCESS':
      report = {
        subArea: 'SubsciberNameUpdate',
        actionType: 'Subscriber Name Update State',
        messageText: 'Success',
        status: 'Completed',
        param1: params?.param1 ?? '',
        param2: params?.param2 ?? '',
        param10: params?.param10 ?? '',
        businessDetails: params?.businessDetails ?? '',
      };
      break;
    case 'UPDATE_FAIL':
      report = {
        subArea: 'SubsciberNameUpdate',
        actionType: 'Subscriber Name Update State',
        messageText: 'General Error',
        status: 'Error',
        param1: params?.param1 ?? '',
        param2: params?.param2 ?? '',
        param10: params?.param10 ?? '',
      };
      break;

    case 'IMEI_EDIT_CLICK':
      report = {
        subArea: 'SubsciberNameUpdate',
        actionType: 'Subscriber Details Page',
        messageText: 'Subscriber IMEI Edit Clicked',
        status: 'Ongoing',
        param1: selectedHetPay ?? '',
        param2: formType ?? '',
        param3: params.param3 ?? '',
        param10: customerNumber ?? '',
      };
      break;
    case 'IMEI_ADD_CLICK':
      report = {
        subArea: 'SubsciberNameUpdate',
        actionType: 'Subscriber Details Page',
        messageText: 'Subscriber IMEI Add Button Clicked',
        status: 'Ongoing',
        param1: selectedHetPay ?? '',
        param2: formType ?? '',
        param3: params.param3 ?? '',
        param10: customerNumber ?? '',
      };
      break;
    case 'IMEI_DELETE_CLICK':
      report = {
        subArea: 'SubsciberNameUpdate',
        actionType: 'Subscriber IMEI Update State',
        messageText: 'Subscriber IMEI Delete  Button Clicked',
        status: 'Ongoing',
        param1: selectedHetPay ?? '',
        param2: formType ?? '',
        param3: params.param3 ?? '',
        param4: 'הסרה',
        param10: customerNumber ?? '',
      };
      break;
    case 'IMEI_SAVE_CLICK':
      report = {
        subArea: 'SubsciberNameUpdate',
        actionType: 'Subscriber IMEI Update State',
        messageText: 'Subscriber IMEI Update Clicked',
        status: 'Ongoing',
        param1: selectedHetPay ?? '',
        param2: formType ?? '',
        param3: params.param3 ?? '',
        param4: 'הוספה',
        param10: customerNumber ?? '',
      };
      break;
    case 'IMEI_ERROR':
      report = {
        subArea: 'SubsciberNameUpdate',
        actionType: 'Subscriber IMEI Update State',
        messageText: 'General Error IMEI',
        status: 'Error',
        param1: selectedHetPay ?? '',
        param2: formType ?? '',
        param3: params.param3 ?? '',
        param4: params.param4 ? 'הוספה' : 'הסרה',
        param10: customerNumber ?? '',
      };
      break;
    case 'IMEI_SUCCESS':
      report = {
        subArea: 'SubsciberNameUpdate',
        actionType: 'Subscriber IMEI Update State',
        messageText: 'Success IMEI ',
        status: 'Completed',
        param1: selectedHetPay ?? '',
        param2: formType ?? '',
        param3: params.param3 ?? '',
        param4: params.param4 ? 'הוספה' : 'הסרה',
        param10: customerNumber ?? '',
        businessDetails: params.businessDetails ?? '',
      };
      break;
  }
  return report;
};
